import { Link } from "react-router-dom";
import { Href } from "../../../../../constants";
import { useAppDispatch } from "../../../../../reduxToolkit/hooks";
import { addToCartData } from "../../../../../reduxToolkit/reducers/eCommerce/cartSlice";
import { HoverLinksProp, ProductItems } from "../../../../../types/Ecommerce";
import { routes } from "../../../../../routers/routes";

  // This component displays hoverable action links for a product, allowing users to add items to the cart or open a modal for quick view.
const HoverLinks: React.FC<HoverLinksProp> = ({ item, setDataId, setOpenModal }) => {

  const dispatch = useAppDispatch();
  const AddToCarts = (item: ProductItems, quantity: number) => dispatch(addToCartData({ item, quantity }));
  const onClickHandle = (i: ProductItems) => {
    setOpenModal(true);
    setDataId(i.id);
  };

  return (
    <div className="product-hover">
      <ul>
        <li>
          <Link to={routes.ECommerce.Cart} color="transparent" onClick={() => AddToCarts(item, 1)}>
            <i className="icon-shopping-cart"></i>
          </Link>
        </li>
        <li>
          <Link to={Href} color="transparent" onClick={() => onClickHandle(item)}>
            <i className="icon-eye"></i>
          </Link>
        </li>
      </ul>
    </div>
  );
};
export default HoverLinks;